<div>
    <!-- <div class="actions">
      <button (click)="addVehicle()" class="btn-action">
        <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin"></fa-icon>
        Add Vehicle</button>
      <button (click)="bulkUpload()" class="btn-action">
        <fa-icon [icon]="['fas', 'upload']" class="fa-solid"></fa-icon>
        Bulk Upload</button>
    </div> -->
    
    <div class="container-table">
      <header class="top-header">
      <h3>Events</h3>
      <p>Event Details As On 20-12-2023</p>
    </header>
      
      <div>
        <div class="tab-head">
          <div class="search-bar">
            <div>
              <!-- <input name='searchText' type="text" [ngModel]="searchText" placeholder="Search" (click)="vehicleSearch()"> -->
              <form  (ngSubmit)="searchEvents()">
                <input type="text" [(ngModel)]="searchText" name='searchText' id="searchText" placeholder="Search">
                <!-- (input)="searchVehicles(currentPage, recordsPerPage)"  -->
                <button type="submit" style="width: 40px; height: 40px; border-radius: 50%; border: none; background: rgb(37, 139, 229); cursor: pointer;" hidden>
                  <fa-icon [icon]="['fas', 'magnifying-glass']" class="fa-thin" style="color: rgb(228, 235, 237);font-size: 20px;"></fa-icon>
                </button>
              </form>
            </div>
          </div>
          <button (click)="exportToExcel()" class="export-button">
            <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin" style="color: white;font-size: 15px;"></fa-icon>
            EXPORT EXCEL
          </button>
        </div>
        <div>
          <table>
            <thead>
                <tr>
                <th>S.No</th>
                <th>Event Type</th>
                <th>Created By</th>
                <th>Created At</th>                
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let record of events let i = index ">
                  <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td> <!-- 10 -> pagesize -->
                  <td>{{ record.event_type }}</td>
                  <td>{{ record.username }}</td>
                  <td>{{ record.created_at | date: 'dd-MM-yyyy hh:mm a' }}</td>
                </tr>
            </tbody>
          </table>
        </div>
        <div class="footer">
          <div class="total-records">Total Records: {{ totalRecords }}</div>
          <div class="pagination-controls">
            <label for="recordsPerPage">Records per page </label>
            <select id="recordsPerPage" [(ngModel)]="recordsPerPage" (change)="selectPageSize()" >
                <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
            </select>
            <span>{{ currentPage }} / {{ totalPages }}</span>
            <button (click)="previous()" [disabled]="!previousPage" class="change-page" title="Previous page">
              <fa-icon [icon]="['fas', 'angle-left']" class="fa-light"></fa-icon>
            </button>
            <button (click)="next()" [disabled]="!nextPage" class="change-page" title="Next page">
              <fa-icon [icon]="['fas', 'angle-right']" class="fa-light" style="background-color: none;"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  
 <!-- Modal for showing event -->
 <div *ngIf="showEvent" class="confirmation-modal">
    <div class="modal-content">
      <div class="close">
        <span  (click)="closeEvent()">
          <fa-icon [icon]="['fas', 'circle-xmark']" class="fa-thin"></fa-icon>
        </span>
      </div>
      <div class="mod-text">
        <p>{{event}}</p>
      </div>
    </div>
  </div>